import React from 'react'
import { Route } from 'react-router-dom'
import VerifyEmail from './VerifyEmail';

import { verifyEmail } from "../../../constants/routePaths"

const VerifyEmailRoute = [
  <Route
    key="VerifyEmail"
    exact path={verifyEmail}
    component={VerifyEmail}
  />,
];

export default VerifyEmailRoute